import * as React from "react";
import { useCallback, useContext, useMemo } from "react";
import styled from "styled-components";
import StreamsContext from "contexts/StreamsContext";
const StreamsList = styled.span`
  span:not(:last-child)::after {
    content: ', ';
  }
`;
const StreamsField = ({ value }) => {
  const streams = useContext(StreamsContext);
  const streamsMap = useMemo(() => Object.fromEntries((streams != null ? streams : []).map((stream) => [stream.id, stream])), [streams]);
  const renderStream = useCallback(
    (streamId) => {
      var _a, _b;
      return /* @__PURE__ */ React.createElement("span", { key: streamId, title: streamId }, (_b = (_a = streamsMap[streamId]) == null ? void 0 : _a.title) != null ? _b : streamId);
    },
    [streamsMap]
  );
  return Array.isArray(value) ? /* @__PURE__ */ React.createElement(StreamsList, null, value.map(renderStream)) : renderStream(value);
};
export default StreamsField;
